import "./GameTable.style.css";

import { GamePropertyState } from "../../../utils/states/GamePageStates/GamePropertyState";
import { GameAnswerState } from "../../../utils/states/GamePageStates/GameAnswerState";
import { PropertyType } from "../../../utils/enums/PropertyType";
import { GameSquare } from "../GameSquare/GameSquare";

interface GameTableProps {
  properties: GamePropertyState[];
  gameAnswerStates: GameAnswerState[];
}

const FIRST_ANIMATION_DELAY = 100;
const ANIMATION_DELAY = 200;

export const GameTable = ({ properties, gameAnswerStates }: GameTableProps) => {
  const generateFieldByType = (type: PropertyType, value: string) => {
    switch (type) {
      case PropertyType.Integer:
      case PropertyType.String:
      case PropertyType.Date:
        return <div>{value}</div>;
      case PropertyType.Image:
        return (
          <img className="game-square__image" src={value} alt="Изображение" />
        );
    }
  };

  if (gameAnswerStates.length === 0) {
    return <></>;
  }

  return (
    <div className="game-table">
      <div className="game-table__header">
        <div className="game-table__header-item">Ответ</div>
        {properties.map((property) => (
          <div
            key={`property-${property.id}`}
            className="game-table__header-item"
          >
            {property.name}
          </div>
        ))}
      </div>
      <div className="game-table__body">
        {gameAnswerStates.map((gameAnswerState) => (
          <div className="game-table__row" key={`object-${gameAnswerState.id}`}>
            <div className="game-table__row-item">
              <img
                className="game-table__row-item__image"
                src={gameAnswerState.image}
                alt={gameAnswerState.name}
              />
              {gameAnswerState.name}
            </div>

            {gameAnswerState.gameObjectValues.map((gameObjectValue, index) => {
              return (
                <GameSquare
                  key={`field-${gameAnswerState}-${index}`}
                  value={generateFieldByType(
                    gameObjectValue.type,
                    gameObjectValue.value
                  )}
                  answerStatus={gameObjectValue.answerStatus}
                  animationDelay={
                    FIRST_ANIMATION_DELAY + ANIMATION_DELAY * index
                  }
                />
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};
